import { render } from "./ZhaiBACardPC.vue?vue&type=template&id=6518cee3&scoped=true"
import script from "./ZhaiBACardPC.vue?vue&type=script&lang=js"
export * from "./ZhaiBACardPC.vue?vue&type=script&lang=js"

import "./ZhaiBACardPC.vue?vue&type=style&index=0&id=6518cee3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6518cee3"]])

export default __exports__